import * as React from 'react';
import { useState } from 'react';
import { toast } from 'react-toastify';

import { Button } from './buttons/Button';
import { axios } from '../api';
import { Close } from '../assets/Close';
import { Order } from '../pages/types';
import { BOTTOM_TOAST, generateErrorMsg } from '../utils';

type DiscountDeletionModalProps = {
  order: Order;
  refreshCustomer: () => void;
  onConfirm: () => void;
  onCancel: () => void;
};

export const DiscountDeletionModal = ({
  order,
  refreshCustomer,
  onCancel,
  onConfirm,
}: DiscountDeletionModalProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const discountCode = order.discounts[0].discount.code;

  const handleSubmit = () => {
    setIsSubmitting(true);
    axios
      .post(`orders/${order.id}/remove_discount`, {
        discount_code: discountCode,
      })
      .then(() => {
        const toastMsg = `Discount removed from order.`;
        toast.success(toastMsg, BOTTOM_TOAST);
        onConfirm();
        refreshCustomer();
      })
      .catch((e) => {
        toast.error(generateErrorMsg(e), BOTTOM_TOAST);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 modal">
      <div className="bg-white rounded-lg shadow-md p-6 min-w-[500px] relative border">
        <Close className="absolute top-1 right-1 w-8 h-8 cursor-pointer" onClick={onCancel} />
        <h2 className="font-bold text-center">
          Are you sure you want to <span style={{ textDecoration: 'underline' }}>remove</span>
          <br />
          discount code <span className="font-bold">{discountCode}</span> from <br /> this order?
        </h2>
        <div className="mt-[15px] w-full flex justify-center">
          <Button
            label="Confirm"
            variant="primary"
            isDisabled={isSubmitting}
            onClick={() => handleSubmit()}
          />
        </div>
      </div>
    </div>
  );
};
